// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'interVariable', 'interVariable Fallback'","fontStyle":"normal"},"className":"__className_3d6e5c","variable":"__variable_3d6e5c"};